<template>
  <svg viewbox="0 0 70 70" class="circular-chart">
    <path class="circle"
      :stroke-dasharray="`${percent}, 100`"
      d="M18 2.0845
        a 15.9155 15.9155 0 0 1 0 31.831
        a 15.9155 15.9155 0 0 1 0 -31.831"
    />
  </svg>
</template>

<script>
export default {
  props: {
    percent: Number,
  },
};
</script>


<style lang="scss" scoped>
.circle {
  fill: none;
  stroke-width: 15;
  transform: translate3d(5px, 5px, 0) scale(0.3);
  animation: progress $transition*2 ease-out forwards;
}
.circular-chart {
  &_red {
    .circle {
      stroke: $red-color8;
    }
  }
  &_orange {
    .circle {
      stroke: $orange-color2;
    }
  }
  &_yellow {
    .circle {
      stroke: $yellow-color1;
    }
  }
  &_green {
    .circle {
      stroke: $green-color1;
    }
  }
  &_substrate {
    .circle {
      animation: none;
      stroke: $grey-color6;
    }
  }
}

.circular-chart {
  width: 18px;
  height: 18px;
  transform: scale(-1, 1);
  display: inline-block;
  margin-right: 8px;
  position: relative;
  z-index: 2;
}

@keyframes progress {
  0% {
    stroke-dasharray: 0 100;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/icons/IconCircleBar.vue